/* eslint-disable react/require-default-props */
import React from 'react';
import AiManagementFiltersBar from 'components/molecules/ai_management_filters_bar';
import { Container } from './styles';

export type ViewMode = 'kanban' | 'lista' | 'calendario';

const VIEW_MODES: { key: ViewMode; label: string; icon: string }[] = [
  { key: 'kanban', label: 'Kanban', icon: 'view_kanban' },
  { key: 'lista', label: 'Lista', icon: 'view_list' },
  { key: 'calendario', label: 'Calendário', icon: 'calendar_today' },
];

interface AiManagementViewSwitcherProps {
  viewMode: ViewMode;
  onChange: (mode: ViewMode) => void;
  showFilters?: boolean;
}

const AiManagementViewSwitcher: React.FC<AiManagementViewSwitcherProps> = ({
  viewMode,
  onChange,
  showFilters = false,
}) => (
  <Container className="d-flex align-items-center py-3">
    <div className="btn-group flex-shrink-0" role="group" aria-label="Modo de visualização">
      {VIEW_MODES.map((mode) => (
        <button
          key={mode.key}
          type="button"
          className={`btn btn-sm d-flex align-items-center ${
            viewMode === mode.key ? 'btn-dark' : 'btn-outline-secondary'
          }`}
          onClick={() => onChange(mode.key)}
        >
          <i className="material-icons mr-1">{mode.icon}</i>
          {mode.label}
        </button>
      ))}
    </div>

    {showFilters && <AiManagementFiltersBar />}
  </Container>
);

export default AiManagementViewSwitcher;
